import home from '../assets/images/Sidebar Icon/home.png';
import item from '../assets/images/Sidebar Icon/item.png';
import scan from '../assets/images/Sidebar Icon/scan.png';
import past from '../assets/images/Sidebar Icon/past.png';
import inventory from '../assets/images/Sidebar Icon/inventory.png';

const warehousesidebar = [
    {
        navigation: "/home",
        icon: home,
        label: "Home",
    },
    {
        navigation: "/products",
        icon: item,
        label: "Product",
    },
    {
        navigation: "/scanbarcode",
        icon: scan,
        label: "Scan Barcode",
    },
    {
        navigation: "/pasttransactions",
        icon: past,
        label: "Past Transactions",
    },
    {
        navigation: "/inventory/products",
        icon: inventory,
        label: "Inventory",
    },
]

export { warehousesidebar };